import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DragDropItemComponentType, DragDropItemEventDto } from '../../models/drag-drop-item.models';
import { IDependentItem } from '../../models/idependent-item';
import { IItemScratchPadChangeEventType } from '../../models/iitem-scratch-pad-change-event-type';
import { IScopingItemGroupMapping } from '../../models/iscoping-item-group-mapping';
import { ItemManagementBrokerService } from '../../services/item-management-broker.service';

@Component({
  selector: 'app-drag-drop-item-base',
  template: '',
  styleUrls: ['./drag-drop-item-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class DragDropItemBaseComponent {
  brokerService = inject(ItemManagementBrokerService);

  public dragDropComponentType = DragDropItemComponentType;
  public lastEvent: DragDropItemEventDto = null;
  public changesMade: boolean = false;

  public onDragOver(event: any) {
    event.preventDefault();
  }

  public onDropScopingItem(event: any, componentType: DragDropItemComponentType, ScopingItemId: number) {

    var jsonData = event.dataTransfer.getData('application/json');
    event.data = JSON.parse(jsonData);
    event.data.source = 'ScopingItemsGrid';

    // Disable dropping of dependent item to the scratch pad
    if (event.data.ItemScopingCategoryId == null)
      return;

    let dropEventDto: DragDropItemEventDto = { event: event, componentType: componentType, ScopingItemId: ScopingItemId };
    this.lastEvent = dropEventDto;

    this.brokerService.DragDropEvent.next(dropEventDto);
  }

  public onDropDependentItem(event: any, componentType: DragDropItemComponentType, ScopingItemId: number) {

    var jsonData = event.dataTransfer.getData('application/json');
    event.data = JSON.parse(jsonData);
    event.data.source = 'DependentItemsGrid';

    // Disable dropping of scoping item under another scoping item
    if (event.data.ItemScopingCategoryId != null)
      return;

    let dropEventDto: DragDropItemEventDto = { event: event, componentType: componentType, ScopingItemId: ScopingItemId };
    this.lastEvent = dropEventDto;

    this.brokerService.DragDropEvent.next(dropEventDto);
  }

  public removeGroup(group: IScopingItemGroupMapping) {
    this.brokerService.ScratchPadChangeEvent.next({ data: group, type: IItemScratchPadChangeEventType.Deleted });
  }

  public removeDependentItemFromScopingItem(dependentItem: IDependentItem, scopingItemId: number) {
    this.brokerService.DeleteDependentItemEvent.next({ dependentItem: dependentItem, destScopingItemId: scopingItemId });
  }
}